module.exports = __webpack_public_path__ + "img/1552247974.afa0ee74.jpg";